module.exports = __webpack_public_path__ + "prism.png?90e2caf0a775e093d50bf177da619383";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prism.png
// module id = 53
// module chunks = 0